import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1395cc76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-mfa-page" }

import { computed, ref } from 'vue'
import { faCircleCheck } from 'fontawesome/free-solid-svg-icons'
import Typography from '@/components/Rain/Typography/Typography.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import PillButton from '@/components/PillButton.vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getMFACode } from '@/api/mfa'


export default /*#__PURE__*/_defineComponent({
  __name: 'MFAReset',
  setup(__props) {

const store = useStore()
const router = useRouter()

const loading = ref(false)
const companyVars = computed(() => store.getters['$companyVars'])

async function resetMFA() {
    loading.value = true
    let result = await getMFACode(false)
    if (result.data.success) {
        await store.dispatch('saveHasMFA', false)
        await router.replace({ name: 'mfa-setup' })
    }
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FontAwesomeIcon), {
      class: "key-icon",
      icon: _unref(faCircleCheck)
    }, null, 8, ["icon"]),
    _createVNode(Typography, {
      variant: "h4",
      component: "h4",
      class: "reset reset-title-container"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" MFA Successfully Setup ")
      ], undefined, true),
      _: 1
    }),
    (!companyVars.value.has_enforce_mfa)
      ? (_openBlock(), _createBlock(PillButton, {
          key: 0,
          label: "Reset MFA",
          disabled: loading.value,
          class: "is-v4",
          onClick: resetMFA
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})